import { IBase } from '@shared/interfaces';
import { IAttachment } from '@shared/interfaces/mailing';

export interface IFaq extends IBase {
    parentIds?: string[];
    translationKey?: string;
    title?: { [key: string]: string } | string;
    sortIndex?: number;
    content?: { [key: string]: string };
    items?: IFaq[];
    event?: () => void;
    isVisible?: () => boolean;
    visibility?: IFaqVisibility;
    totalItems?: number;
    active?: boolean;
    hasGuidance?: boolean;
    videoLink?: string;
    documents?: IAttachment[];
    documentsDE?: IAttachment[];
    documentsEN?: IAttachment[];
    deFilePath?: string;
    enFilePath?: string;
}

export enum IFaqVisibility {
    All = 'all',
    Admin = 'admin',
    Master = 'master'
}
